import { ErrorMessage, Form, Formik } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  Input,
  SelectInput,
} from "../../../../../_metronic/_partials/controls";
import API from "../../../../helpers/devApi";
import moment from "moment";
import * as Yup from "yup";
import * as Action from "../../../applicant/_redux/applicantActions";
import * as EmployeeListAction from "../../../employee/_redux/employeeActions";
import { swalConfirm, swalError, swalSuccess } from "../../../../helpers/swal";
import { Button, Modal } from "react-bootstrap";
import { Checkbox, DatePicker } from "antd";

const options = [
  {
    value: "Enrolled",
    label: "Enrolled",
  },
  {
    value: "Progress",
    label: "Progress",
  },
  {
    value: "Awarded",
    label: "Awarded",
  },
];
const modality = [
  {
    value: "In-Person",
    label: "In-Person",
  },
  {
    value: "Hybrid",
    label: "Hybrid",
  },
  {
    value: "Online",
    label: "Online",
  },
];

const _init = {
  certification_name: "",
  institute: "",
  country_id: "",
  enrollment_id: "",
  duration: null,
  from_date: "",
  to_date: "",
  status: "",
  valid_till: null,
  certification_url: "",
  modality: "",
  is_not_available: false,
};

const Certification = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [certificateData, setCertificateData] = useState();
  const dispatch = useDispatch();
  const {
    certificate,
    countryList,
    certificationList,
    employeeProfile,
    personalInfo,
  } = useSelector(
    ({ applicant, employeeList }) => ({
      employeeProfile: employeeList.employeeProfile,
      certificate: applicant.certificate,
      countryList: applicant.countryList,
      certificationList: applicant.certificationList,
      personalInfo: applicant.personal_info,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (id) {
      dispatch(Action.getAllCertificateByApplicants(id));
      dispatch(Action.getApplicantPersonalInfo(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    if (certificationList && certificationList.length > 0) {
      const data = certificationList?.map((item) => {
        return {
          id: item?.hrms_professional_certification__id,
          certification_name:
            item?.hrms_professional_certification__certification_name,
          institute: item?.hrms_professional_certification__institute,
          country_id: item?.hrms_professional_certification__country_id,
          enrollment_id: item?.hrms_professional_certification__enrollment_id,
          status: item?.hrms_professional_certification__status,
          valid_till: item?.hrms_professional_certification__valid_till,
          certification_url:
            item?.hrms_professional_certification__certification_url,
          modality: item?.hrms_professional_certification__modality,
          duration: item?.hrms_professional_certification__duration,
          is_not_available:
            item?.hrms_professional_certification__is_not_available,
          certificate_file:
            item?.hrms_professional_certification__certificate_file,
          from_date: item.hrms_professional_certification__from_date
            ? moment(item.hrms_professional_certification__from_date)
            : null,
          to_date: item.hrms_professional_certification__to_date
            ? moment(item.hrms_professional_certification__to_date)
            : null,
        };
      });
      setCertificateData({ list: data });
    } else {
      // setCertificateData({ list: [_init] });
      setCertificateData({ list: [] });
    }
  }, [certificationList]);

  // Validation schema
  const validationSchema = Yup.object().shape({
    list: Yup.array().of(
      Yup.object().shape({
        certification_name: Yup.string()
          .nullable()
          .required("certification is required"),
        country_id: Yup.number().required("Country is required"),
        enrollment_id: Yup.number()
          .nullable()
          .required("Enrollment id is required"),
        from_date: Yup.string().required("from date is required"),
        to_date: Yup.string().required("end date is required"),

        // to_date: Yup.date()
        //     .required("Start date is required")
        //     .nullable(),
        // from_date: Yup.date()
        //     .required("End date is required")
        //     .nullable()
        //     .test(
        //         "is-after-start",
        //         "End date must be later than Start date",
        //         function (value) {
        //             const { to_date } = this.parent;
        //             return to_date && value ? value > to_date : true;
        //         }
        //     ),
        institute: Yup.string().required("institute is required"),
        modality: Yup.string().required("modality is required"),
        status: Yup.string().required("status is required"),
        duration: Yup.number().required("Duration is required"),
        valid_till: Yup.date().when(
          ["status", "is_not_available"],
          (status, is_not_available) => {
            if (status === "Awarded" && !is_not_available) {
              return Yup.date()
                .typeError("Required")
                .nullable()
                .required("Required");
            } else {
              return Yup.date().nullable();
            }
          }
        ),
      })
    ),
  });

  const handleSaveProfile = async (values) => {
    if (id && values?.list !== undefined) {
      if (values && values?.list) {
        let index = 0;
        let success = false;

        // const formData = values.list.map((item) => {
        //   return {
        //     ...item,
        //     applicant_id: id
        //   }
        // })
        for (let value of values.list) {
          // const formData = new FormData();
          // formData.append("certification_name", value.certification_name);
          // formData.append("country_id", value.country_id);
          // formData.append("certification_url", value.certification_url);
          // formData.append("is_not_available", value.is_not_available);
          // formData.append("modality", value.modality);
          // formData.append("status", value.status);
          // formData.append(
          //   "valid_till",
          //   value.valid_till == "" ? null : value.valid_till
          // );
          // formData.append("duration", value.duration);
          // formData.append("enrollment_id", value.enrollment_id);
          // formData.append(
          //   "from_date",
          //   moment(value.from_date).format("YYYY-MM-DD")
          // );
          // formData.append("institute", value.institute);
          // formData.append(
          //   "to_date",
          //   moment(value.to_date).format("YYYY-MM-DD")
          // );
          // formData.append("file", value.upload_document);
          // formData.append("certificate_file", value.certificate_file ?? "");
          // formData.append("applicant_id", value.applicant_id ?? id);
          value.from_date = moment(value.from_date).format("YYYY-MM-DD");
          value.to_date = moment(value.to_date).format("YYYY-MM-DD");
          value.applicant_id = id;
          const response = await API.post(
            `/hrms_professional_certification/create_professional_certification?current=${index}`,
            value
          );
          success = response.data.success;
          if (!success) {
            break;
          }
          index++;
        }
        if (!values?.list?.length) {
          const response = await API.post(
            `/hrms_professional_certification/create_professional_certification?current=${0}`,
            {
              applicant_id: id,
            }
          );
          success = response.data.success;
        }
        if (success) {
          swalSuccess("Professional Certification Updated Successfully");
          if (values?.list?.length) {
            dispatch(
              Action.createProfileScore(
                {
                  name: ["Professional Certification"],
                  applicant_id: id,
                },
                () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                }
              )
            );
          } else {
            dispatch(
              Action.updateProfileScore(
                {
                  name: ["Professional Certification"],
                  applicant_id: id,
                },
                () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                }
              )
            );
          }
        } else {
          swalError("Professional Certification Failed To Save");
        }
        // values.list.forEach((item, key) => {
        //   if (item?.upload_document) {
        //     console.log(typeof item?.upload_document);
        //     formData.append(`file_${key}`, item?.upload_document);
        //   }
        // });
      }

      // const insertData = values?.list?.map((item) => {
      //   return {
      //     certification_id: item?.certification_id,
      //     institute: item?.institute,
      //     country_id: item?.country_id,
      //     enrollment_id: item?.enrollment_id,
      //     duration: item?.duration,
      //     from_date: item?.from_date,
      //     to_date: item?.to_date,
      //     applicant_id: id,
      //   };
      // });

      // formData.append(`data`, JSON.stringify(insertData));

      // if (formData.get("data")) {
      //   setLoading(true);

      //   await API.post(`/hrms_professional_certification/store`, formData)
      //     .then(async (res) => {
      //       if (res.data.success) {
      //         await dispatch(Action.getAllCertificateByApplicants(id));
      //         swalSuccess("Certifications Information Updated Successfully!!");
      //         setLoading(false);
      //       } else {
      //         swalError("something went wrong");
      //       }
      //     })
      //     .catch((error) => {
      //       console.error(error);
      //     });
      //   setLoading(false);
      // }
    }
  };

  const handleDelete = async (itemId, index) => {
    swalConfirm().then(async (res) => {
      if (res.isConfirmed) {
        const list = certificateData?.list;
        list.splice(index, 1);
        setCertificateData({ list: list });
      }
    });
  };

  const handleAdd = async (values) => {
    const newArray = [...values.list];
    let data = [...newArray, _init];
    setCertificateData({ list: data });
  };

  useEffect(() => {
    dispatch(Action.getAllCertificate());
  }, [dispatch]);

  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  const handleOnChangeNoCertificate = (no_certificate) => {
    const api = `/hrms_applicant/${id}`;
    API.patch(api, { no_certificate })
      .then((res) => {
        if (res.data.success) {
          swalSuccess("Data updated successfully");
          if (no_certificate) {
            dispatch(
              Action.createProfileScore(
                {
                  name: ["Professional Certification"],
                  applicant_id: id,
                },
                () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                }
              )
            );
          } else {
            dispatch(
              Action.updateProfileScore(
                {
                  name: ["Professional Certification"],
                  applicant_id: id,
                },
                () => {
                  dispatch(Action.getApplicantPersonalInfo(id));
                }
              )
            );
          }
        } else {
          if (res.data.message) {
            swalError(res.data.message);
          } else {
            swalError("something went wrong");
          }
        }
      })
      .catch((error) => {
        console.log(error);
        swalError("something went wrong");
      });
  };

  return (
    <div className="card card_body_box mb-5">
      <Formik
        initialValues={certificateData}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          setCertificateData(values);
          handleSaveProfile(values);
        }}
      >
        {({ handleSubmit, setFieldValue, values, errors, touched }) => (
          <Form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-12">
                <div className="card_header_with_edit_btn">
                  <div className="title">
                    <h2>Professional Certification</h2>
                  </div>
                </div>

                <hr />
              </div>
            </div>
            {values?.list?.map((item, i, row) => (
              <div className="row" key={i}>
                <div className="col-md-12 mb-4">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          {/* <SelectInput
                            name={`list[${i}].certification_id`}
                            label={"Certification"}
                            options={certificate}
                            isRequired
                            value={item.certification_id}
                            onChange={(value) => {
                              setFieldValue(
                                `list[${i}].certification_id`,
                                value
                              );
                            }}
                          /> */}
                          <Input
                            name={`list[${i}].certification_name`}
                            label={"Certification"}
                            type="text"
                            isRequired
                            value={item.certification_name}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].certification_name`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage
                              name={`list[${i}].certification_name`}
                            />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].enrollment_id`}
                            label={"Enrollment ID"}
                            type="number"
                            isRequired
                            value={item.enrollment_id}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].enrollment_id`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].enrollment_id`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].institute`}
                            label={"Institute"}
                            isRequired
                            value={item.institute}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].institute`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].institute`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <SelectInput
                            name={`list[${i}].country_id`}
                            label={"Country"}
                            options={countryList}
                            isRequired
                            value={item.country_id}
                            onChange={(value) => {
                              setFieldValue(`list[${i}].country_id`, value);
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].country_id`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="required"> Start date</label>
                          <DatePicker
                            style={{ width: "100%" }}
                            value={item.from_date ? moment(item.from_date) : ""}
                            onChange={(val, date) => {
                              setFieldValue(`list[${i}].from_date`, date);
                              setFieldValue(`list[${i}].to_date`, "");
                              if (val && item.to_date) {
                                let durationTime = moment(item.to_date).diff(
                                  moment(val),
                                  "months"
                                );
                                // const averageDaysPerMonth = 30.44;
                                // const monthsDiff = Number(durationTime / averageDaysPerMonth).toFixed(2);
                                setFieldValue(
                                  `list[${i}].duration`,
                                  durationTime
                                );
                              }
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].from_date`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <label className="required">End date</label>
                          <DatePicker
                            style={{ width: "100%" }}
                            value={item.to_date ? moment(item.to_date) : ""}
                            disabledDate={(current) => {
                              // If there is a start date, use it as the minimum selectable date for the end date.
                              // Otherwise, use the current date.
                              const startDate = item.from_date
                                ? moment(item.from_date)
                                : moment();
                              return (
                                current && current < startDate.startOf("day")
                              );
                            }}
                            onChange={(val, date) => {
                              setFieldValue(`list[${i}].to_date`, date);
                              if (val && item.from_date) {
                                let durationTime = moment(val).diff(
                                  moment(item.from_date),
                                  "months"
                                );
                                // var months = durationTime.asMonths();
                                // const averageDaysPerMonth = 30.44;
                                // const monthsDiff = Number(durationTime / averageDaysPerMonth).toFixed(2);
                                setFieldValue(
                                  `list[${i}].duration`,
                                  durationTime
                                );
                              }
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].to_date`} />
                          </div>
                        </div>

                        {/*<div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].duration`}
                            label={"Duration (In Months)"}
                            isRequired
                            disabled
                            value={item.duration}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].duration`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].duration`} />
                          </div>
                        </div>*/}
                        {/* <div className="col-md-6 mb-3 d-flex">
                                                        <div className='mr-2'>
                                                            <Input
                                                                name={`list[${i}].upload_document`}
                                                                type='file'
                                                                label={"Upload Document"}
                                                                onChange={(e) => {
                                                                    setFieldValue(`list[${i}].upload_document`, e.target.files[0]);
                                                                }}
                                                            />
                                                            <div className="text-danger">
                                                                <ErrorMessage name={`list[${i}].upload_document`} />
                                                            </div>
                                                        </div>
                                                        <div className='pt-7'>
                                                            <span style={{ color: "#00000073", fontFamily: 'Roboto', fontSize: "14px", fontWeight: '400' }}>Recommended format is pdf with file size less than 25MB</span>
                                                        </div>
                                                    </div> */}

                        <div className="col-md-6 mb-3">
                          <SelectInput
                            name={`list[${i}].status`}
                            label={"Status"}
                            options={options}
                            isRequired
                            value={item.status}
                            onChange={(value) => {
                              setFieldValue(`list[${i}].status`, value);
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].status`} />
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <SelectInput
                            name={`list[${i}].modality`}
                            label={"Modality"}
                            options={modality}
                            isRequired
                            value={item.modality}
                            onChange={(value) => {
                              setFieldValue(`list[${i}].modality`, value);
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].modality`} />
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].certification_url`}
                            label={"Certification URL"}
                            value={item.certification_url}
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].certification_url`,
                                e.target.value
                              );
                            }}
                          />
                          <div className="text-danger">
                            <ErrorMessage
                              name={`list[${i}].certification_url`}
                            />
                          </div>
                        </div>

                        {item.status === "Awarded" && (
                          <div className="col-md-6 mb-3">
                            <label
                              className={
                                !item.is_not_available ? "required" : ""
                              }
                            >
                              Valid date
                            </label>
                            <DatePicker
                              style={{ width: "100%" }}
                              value={
                                item.valid_till ? moment(item.valid_till) : null
                              }
                              disabled={item.is_not_available}
                              onChange={(val, date) => {
                                setFieldValue(`list[${i}].valid_till`, date);
                              }}
                            />
                            <Checkbox
                              checked={item.is_not_available}
                              onChange={(e) => {
                                setFieldValue(
                                  `list[${i}].is_not_available`,
                                  e.target.checked
                                );

                                setFieldValue(`list[${i}].valid_till`, null);
                              }}
                            >
                              Not Applicable
                            </Checkbox>
                            <div className="text-danger">
                              <ErrorMessage name={`list[${i}].valid_till`} />
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="row">
                        <div className="col-md-6 mb-3 d-flex">
                          {i === values?.list?.length - 1 && (
                            <button
                              type="button"
                              className="btn  add-button btn-sm text-white mr-5 text-nowrap"
                              onClick={() => {
                                // setCertificateData(values);
                                handleAdd(values);
                              }}
                            >
                              <i
                                className="fa fa-plus text-white"
                                aria-hidden="true"
                              ></i>
                              Add Certification
                            </button>
                          )}
                          {row.length > 0 && (
                            <button
                              type="button"
                              className="btn btn-danger btn-sm  text-nowrap"
                              onClick={() => {
                                handleDelete(item.id, i);
                              }}
                            >
                              <i
                                className="fa fa-minus  text-white"
                                aria-hidden="true"
                              ></i>
                              Remove Certification
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {!values?.list?.length && (
              <div className="row">
                <div
                  className="col-md-12"
                  style={{ display: "flex", gap: "2" }}
                >
                  {!personalInfo?.no_certificate && (
                    <button
                      type="button"
                      className="btn add-button btn-sm text-white mr-5 text-nowrap"
                      onClick={() => {
                        handleAdd(values);
                      }}
                    >
                      <i
                        className="fa fa-plus text-white"
                        aria-hidden="true"
                      ></i>
                      Add Certification
                    </button>
                  )}
                  <div className="align-content-center">
                    <Checkbox
                      type="checkbox"
                      checked={personalInfo?.no_certificate}
                      id="no_certificate"
                      onChange={(e) => {
                        handleOnChangeNoCertificate(e.target.checked ? 1 : 0);
                      }}
                    />
                    <label
                      className="form-check-label ml-2"
                      htmlFor="no_certificate"
                    >
                      <b>Don't have any certificate?</b>
                    </label>
                  </div>
                </div>
              </div>
            )}
            {!personalInfo?.no_certificate && (
              <div className="edit_btn_group d-flex modal-footer m-0 p-0">
                {/* <button className='btn btn-default mr-4' >Cancel</button> */}
                <button
                  type="submit"
                  className="btn btn-primary"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  Save
                </button>
              </div>
            )}
          </Form>
        )}
      </Formik>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Attachments NID</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img
            className="w-100"
            src="https://avatars.githubusercontent.com/u/33831358?v=4"
            alt="img"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Certification;
